<div class="contact-page modal"> 
    <form [formGroup]="loginForm" class="theme-form" (keydown.enter)="$event.preventDefault()">
        <div class="container d-flex justify-content-center">
            <div class="col-10 p-5 modal-body">
                <button class="close-button" (click)="closeModal()">X</button>
                <div class="col-sm-12">
                    <h3>Iniciar Sesión</h3>
                    <div class="row">
                        <div class="form-group">
                            <div class="d-flex">
                                <label for="email">Correo electrónico</label> &nbsp;
                                <label class="text-success" *ngIf="checkout">*Correo verificado, inicia sesión para continuar</label>
                            </div>
                            <input formControlName="username"  type="text" class="form-control" id="email" placeholder="Correo electrónico" required="">
                        </div>
                        <div class="form-group">
                            <label for="review">Contraseña</label>
                            <div class="d-flex">
                                <input (keyup.enter)="onSubmit()"
                                 formControlName="password" [type]="hide ? 'password' : 'text'" class="form-control" id="password" maxlength="16" placeholder="Ingresa tu contraseña" required="">
                                <span class="toggle-password" [ngClass]="{'show-password': !hide, 'hide-password': hide}" (click)="togglePassword()"></span>
                            </div>
                            <div class="d-flex justify-content-center flex-wrap gap-3 align-items-center">
                                <button class="btn btn-solid d-flex flex-wrap" (click)="onSubmit()">Iniciar sesión</button>
                                <button class="btn btn-solid-yellow d-flex flex-wrap"(click)="closeModalGuest(true)">Continuar como invitado</button>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center py-3">
                            <div class="form-group">
                                <a (click)="changeModal(false, true)"><span class="olvidoContrasena">¿Eres nuevo? Regístrate</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>